import React, { useState } from 'react';
import './Fotos.css';

// Importar todas las imágenes de Semana Santa (quitamos Foto6)
import foto1 from '../../Images/semana-santa/foto1.webp';
import foto2 from '../../Images/semana-santa/foto2.webp';
import Foto3 from '../../Images/semana-santa/Foto3.webp';
import Foto4 from '../../Images/semana-santa/Foto4.webp';
import Foto5 from '../../Images/semana-santa/Foto5.webp';
import Foto7 from '../../Images/semana-santa/Foto7.webp';
import Foto8 from '../../Images/semana-santa/Foto8.webp';
import Foto9 from '../../Images/semana-santa/Foto9.webp';
import Foto10 from '../../Images/semana-santa/Foto10.webp';
import Foto11 from '../../Images/semana-santa/Foto11.webp';
import Foto12 from '../../Images/semana-santa/Foto12.webp';
import Foto13 from '../../Images/semana-santa/Foto13.webp';

// Importar imágenes antiguas/históricas
import antigua1 from '../../Images/antiguas/Foto1.webp';
import antigua3 from '../../Images/antiguas/Foto3.webp';
import antigua4 from '../../Images/antiguas/Foto4.webp';
import antigua5 from '../../Images/antiguas/Foto5.webp';
import antigua6 from '../../Images/antiguas/Foto6.webp';
import antigua7 from '../../Images/antiguas/Foto7.webp';
import antigua8 from '../../Images/antiguas/foto8.webp';
import antigua9 from '../../Images/antiguas/Foto9.webp';

// Importar todas las imágenes de patrimonio histórico de la carpeta lugares
import lugar1 from '../../Images/lugares-historicos/lugar1.webp';
import lugar2 from '../../Images/lugares-historicos/lugar2.webp';
import lugar3 from '../../Images/lugares-historicos/lugar3.webp';
import lugar4 from '../../Images/lugares-historicos/lugar4.webp';
import lugar5 from '../../Images/lugares-historicos/lugar5.webp';
import lugar6 from '../../Images/lugares-historicos/lugar6.webp';
import lugar7 from '../../Images/lugares-historicos/lugar7.webp';
import lugar8 from '../../Images/lugares-historicos/lugar8.webp';
import lugar9 from '../../Images/lugares-historicos/lugar9.webp';
import lugar10 from '../../Images/lugares-historicos/lugar10.webp';
import lugar11 from '../../Images/lugares-historicos/lugar11.webp';
import lugar12 from '../../Images/lugares-historicos/lugar12.webp';
import lugar13 from '../../Images/lugares-historicos/lugar13.webp';
import lugar14 from '../../Images/lugares-historicos/lugar14.webp';
import lugar15 from '../../Images/lugares-historicos/lugar15.webp';
import lugar16 from '../../Images/lugares-historicos/lugar16.webp';
import lugar17 from '../../Images/lugares-historicos/lugar17.webp';
import lugar18 from '../../Images/lugares-historicos/lugar18.webp';
import lugar19 from '../../Images/lugares-historicos/lugar19.webp';
import lugar20 from '../../Images/lugares-historicos/lugar20.webp';
import lugar21 from '../../Images/lugares-historicos/lugar21.webp';
import lugar22 from '../../Images/lugares-historicos/lugar22.webp';
import lugar23 from '../../Images/lugares-historicos/lugar23.webp';
import lugar24 from '../../Images/lugares-historicos/lugar24.webp';
import lugar25 from '../../Images/lugares-historicos/lugar25.webp';
import lugar26 from '../../Images/lugares-historicos/lugar26.webp';
import lugar27 from '../../Images/lugares-historicos/lugar27.webp';
import lugar28 from '../../Images/lugares-historicos/lugar28.webp';
import lugar29 from '../../Images/lugares-historicos/lugar29.webp';
import lugar30 from '../../Images/lugares-historicos/lugar30.webp';
import lugar31 from '../../Images/lugares-historicos/lugar31.webp';
import lugar32 from '../../Images/lugares-historicos/lugar32.webp';
import lugar33 from '../../Images/lugares-historicos/lugar33.webp';
import lugar34 from '../../Images/lugares-historicos/lugar34.webp';
import lugar35 from '../../Images/lugares-historicos/lugar35.webp';
import lugar36 from '../../Images/lugares-historicos/lugar36.webp';
import lugar37 from '../../Images/lugares-historicos/lugar37.webp';
import lugar38 from '../../Images/lugares-historicos/lugar38.webp';
import lugar39 from '../../Images/lugares-historicos/lugar39.webp';
import lugar40 from '../../Images/lugares-historicos/lugar40.webp';
import lugar42 from '../../Images/lugares-historicos/lugar42.webp';
import lugar43 from '../../Images/lugares-historicos/lugar43.webp';
import lugar45 from '../../Images/lugares-historicos/lugar45.webp';
import lugar46 from '../../Images/lugares-historicos/lugar46.webp';
import lugar47 from '../../Images/lugares-historicos/lugar47.webp';
import lugar48 from '../../Images/lugares-historicos/lugar48.webp';
import lugar49 from '../../Images/lugares-historicos/lugar49.webp';
import lugar50 from '../../Images/lugares-historicos/lugar50.webp';
import lugar51 from '../../Images/lugares-historicos/lugar51.webp';
import lugar52 from '../../Images/lugares-historicos/lugar52.webp';
import lugar53 from '../../Images/lugares-historicos/lugar53.webp';
import lugar54 from '../../Images/lugares-historicos/lugar54.webp';
import lugar55 from '../../Images/lugares-historicos/lugar55.webp';
import lugar56 from '../../Images/lugares-historicos/lugar56.webp';
import lugar57 from '../../Images/lugares-historicos/lugar57.webp';
import lugar58 from '../../Images/lugares-historicos/lugar58.webp';
import lugar59 from '../../Images/lugares-historicos/lugar59.webp';
import lugar60 from '../../Images/lugares-historicos/lugar60.webp';
import lugar61 from '../../Images/lugares-historicos/lugar61.webp';
import lugar62 from '../../Images/lugares-historicos/lugar62.webp';
import lugar63 from '../../Images/lugares-historicos/lugar63.webp';
import lugar64 from '../../Images/lugares-historicos/lugar64.webp';
import lugar65 from '../../Images/lugares-historicos/lugar65.webp';

const Fotos = () => {
  const [modalImage, setModalImage] = useState(null);

  const openModal = (imageSrc, altText) => {
    setModalImage({ src: imageSrc, alt: altText });
  };

  const closeModal = () => {
    setModalImage(null);
  };

  return (
    <div className="fotos-container">
      <h1>Fotos del Pueblo</h1>
      
      {/* Agradecimiento a Jessica M. */}
      <div className="intro-text agradecimiento" style={{textAlign: 'center'}}>
        <p>
          Queremos dar un especial agradecimiento a <strong>Jessica Martínez de la Casa</strong> por habernos 
          proporcionado estas hermosas fotografías que capturan momentos únicos del pueblo 
          de Escalonilla que perdurarán para siempre. Su sensibilidad artística nos permite 
          contemplar nuestro querido pueblo desde una perspectiva especial, preservando 
          recuerdos y emociones que forman parte de nuestra identidad.
        </p>
      </div>

      {/* Sección Recuerdos del Pasado - AHORA PRIMERO */}
      <div className="categoria-section">
        <h2>Recuerdos del Pasado</h2>
        <p className="categoria-intro">
          Un viaje nostálgico a través del tiempo con fotografías históricas que capturan 
          momentos únicos y la evolución de nuestro querido Escalonilla a lo largo de los años.
        </p>
        
        <div className="fotos-gallery">
          <div className="foto-item" onClick={() => openModal(antigua1, "Recuerdo del Pasado - Escalonilla 1")}>
            <img 
              src={antigua1} 
              alt="Recuerdo del Pasado - Escalonilla 1"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(antigua3, "Recuerdo del Pasado - Escalonilla 3")}>
            <img 
              src={antigua3} 
              alt="Recuerdo del Pasado - Escalonilla 3"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(antigua4, "Recuerdo del Pasado - Escalonilla 4")}>
            <img 
              src={antigua4} 
              alt="Recuerdo del Pasado - Escalonilla 4"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(antigua5, "Recuerdo del Pasado - Escalonilla 5")}>
            <img 
              src={antigua5} 
              alt="Recuerdo del Pasado - Escalonilla 5"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(antigua6, "Recuerdo del Pasado - Escalonilla 6")}>
            <img 
              src={antigua6} 
              alt="Recuerdo del Pasado - Escalonilla 6"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(antigua7, "Recuerdo del Pasado - Escalonilla 7")}>
            <img 
              src={antigua7} 
              alt="Recuerdo del Pasado - Escalonilla 7"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(antigua8, "Recuerdo del Pasado - Escalonilla 8")}>
            <img 
              src={antigua8} 
              alt="Recuerdo del Pasado - Escalonilla 8"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(antigua9, "Recuerdo del Pasado - Escalonilla 9")}>
            <img 
              src={antigua9} 
              alt="Recuerdo del Pasado - Escalonilla 9"
            />
          </div>
        </div>
      </div>

      {/* Sección Semana Santa */}
      <div className="categoria-section">
        <h2>Semana Santa</h2>
        <p className="categoria-intro">
          La Semana Santa de Escalonilla es una de las tradiciones más arraigadas de nuestro 
          pueblo, donde la devoción y el arte se unen en procesiones llenas de emoción y recogimiento.
        </p>
        
        <div className="fotos-gallery">
          <div className="foto-item" onClick={() => openModal(foto1, "Semana Santa Escalonilla - Foto 1")}>
            <img 
              src={foto1} 
              alt="Semana Santa Escalonilla - Foto 1"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(foto2, "Semana Santa Escalonilla - Foto 2")}>
            <img 
              src={foto2} 
              alt="Semana Santa Escalonilla - Foto 2"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(Foto3, "Semana Santa Escalonilla - Foto 3")}>
            <img 
              src={Foto3} 
              alt="Semana Santa Escalonilla - Foto 3"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(Foto4, "Semana Santa Escalonilla - Foto 4")}>
            <img 
              src={Foto4} 
              alt="Semana Santa Escalonilla - Foto 4"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(Foto5, "Semana Santa Escalonilla - Foto 5")}>
            <img 
              src={Foto5} 
              alt="Semana Santa Escalonilla - Foto 5"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(Foto7, "Semana Santa Escalonilla - Foto 7")}>
            <img 
              src={Foto7} 
              alt="Semana Santa Escalonilla - Foto 7"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(Foto8, "Semana Santa Escalonilla - Foto 8")}>
            <img 
              src={Foto8} 
              alt="Semana Santa Escalonilla - Foto 8"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(Foto9, "Semana Santa Escalonilla - Foto 9")}>
            <img 
              src={Foto9} 
              alt="Semana Santa Escalonilla - Foto 9"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(Foto10, "Semana Santa Escalonilla - Foto 10")}>
            <img 
              src={Foto10} 
              alt="Semana Santa Escalonilla - Foto 10"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(Foto11, "Semana Santa Escalonilla - Foto 11")}>
            <img 
              src={Foto11} 
              alt="Semana Santa Escalonilla - Foto 11"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(Foto12, "Semana Santa Escalonilla - Foto 12")}>
            <img 
              src={Foto12} 
              alt="Semana Santa Escalonilla - Foto 12"
            />
          </div>
          <div className="foto-item" onClick={() => openModal(Foto13, "Semana Santa Escalonilla - Foto 13")}>
            <img 
              src={Foto13} 
              alt="Semana Santa Escalonilla - Foto 13"
            />
          </div>
        </div>
      </div>

      {/* Sección Patrimonio Histórico - AHORA DESPUÉS */}
      <div className="categoria-section">
        <h2>Patrimonio Histórico</h2>
        <p className="categoria-intro">
          Descubre los lugares más emblemáticos e históricos de Escalonilla, espacios que guardan 
          la memoria y el legado de nuestro pueblo a través de los siglos.
        </p>
        
        <div className="fotos-gallery">
          <div className="foto-item" onClick={() => openModal(lugar1, "Lugar Histórico de Escalonilla 1")}>
            <img src={lugar1} alt="Lugar Histórico de Escalonilla 1" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar2, "Lugar Histórico de Escalonilla 2")}>
            <img src={lugar2} alt="Lugar Histórico de Escalonilla 2" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar3, "Lugar Histórico de Escalonilla 3")}>
            <img src={lugar3} alt="Lugar Histórico de Escalonilla 3" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar4, "Lugar Histórico de Escalonilla 4")}>
            <img src={lugar4} alt="Lugar Histórico de Escalonilla 4" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar5, "Lugar Histórico de Escalonilla 5")}>
            <img src={lugar5} alt="Lugar Histórico de Escalonilla 5" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar6, "Lugar Histórico de Escalonilla 6")}>
            <img src={lugar6} alt="Lugar Histórico de Escalonilla 6" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar7, "Lugar Histórico de Escalonilla 7")}>
            <img src={lugar7} alt="Lugar Histórico de Escalonilla 7" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar8, "Lugar Histórico de Escalonilla 8")}>
            <img src={lugar8} alt="Lugar Histórico de Escalonilla 8" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar9, "Lugar Histórico de Escalonilla 9")}>
            <img src={lugar9} alt="Lugar Histórico de Escalonilla 9" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar10, "Lugar Histórico de Escalonilla 10")}>
            <img src={lugar10} alt="Lugar Histórico de Escalonilla 10" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar11, "Lugar Histórico de Escalonilla 11")}>
            <img src={lugar11} alt="Lugar Histórico de Escalonilla 11" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar12, "Lugar Histórico de Escalonilla 12")}>
            <img src={lugar12} alt="Lugar Histórico de Escalonilla 12" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar13, "Lugar Histórico de Escalonilla 13")}>
            <img src={lugar13} alt="Lugar Histórico de Escalonilla 13" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar14, "Lugar Histórico de Escalonilla 14")}>
            <img src={lugar14} alt="Lugar Histórico de Escalonilla 14" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar15, "Lugar Histórico de Escalonilla 15")}>
            <img src={lugar15} alt="Lugar Histórico de Escalonilla 15" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar16, "Lugar Histórico de Escalonilla 16")}>
            <img src={lugar16} alt="Lugar Histórico de Escalonilla 16" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar17, "Lugar Histórico de Escalonilla 17")}>
            <img src={lugar17} alt="Lugar Histórico de Escalonilla 17" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar18, "Lugar Histórico de Escalonilla 18")}>
            <img src={lugar18} alt="Lugar Histórico de Escalonilla 18" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar19, "Lugar Histórico de Escalonilla 19")}>
            <img src={lugar19} alt="Lugar Histórico de Escalonilla 19" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar20, "Lugar Histórico de Escalonilla 20")}>
            <img src={lugar20} alt="Lugar Histórico de Escalonilla 20" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar21, "Lugar Histórico de Escalonilla 21")}>
            <img src={lugar21} alt="Lugar Histórico de Escalonilla 21" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar22, "Lugar Histórico de Escalonilla 22")}>
            <img src={lugar22} alt="Lugar Histórico de Escalonilla 22" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar23, "Lugar Histórico de Escalonilla 23")}>
            <img src={lugar23} alt="Lugar Histórico de Escalonilla 23" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar24, "Lugar Histórico de Escalonilla 24")}>
            <img src={lugar24} alt="Lugar Histórico de Escalonilla 24" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar25, "Lugar Histórico de Escalonilla 25")}>
            <img src={lugar25} alt="Lugar Histórico de Escalonilla 25" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar26, "Lugar Histórico de Escalonilla 26")}>
            <img src={lugar26} alt="Lugar Histórico de Escalonilla 26" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar27, "Lugar Histórico de Escalonilla 27")}>
            <img src={lugar27} alt="Lugar Histórico de Escalonilla 27" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar28, "Lugar Histórico de Escalonilla 28")}>
            <img src={lugar28} alt="Lugar Histórico de Escalonilla 28" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar29, "Lugar Histórico de Escalonilla 29")}>
            <img src={lugar29} alt="Lugar Histórico de Escalonilla 29" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar30, "Lugar Histórico de Escalonilla 30")}>
            <img src={lugar30} alt="Lugar Histórico de Escalonilla 30" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar31, "Lugar Histórico de Escalonilla 31")}>
            <img src={lugar31} alt="Lugar Histórico de Escalonilla 31" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar32, "Lugar Histórico de Escalonilla 32")}>
            <img src={lugar32} alt="Lugar Histórico de Escalonilla 32" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar33, "Lugar Histórico de Escalonilla 33")}>
            <img src={lugar33} alt="Lugar Histórico de Escalonilla 33" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar34, "Lugar Histórico de Escalonilla 34")}>
            <img src={lugar34} alt="Lugar Histórico de Escalonilla 34" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar35, "Lugar Histórico de Escalonilla 35")}>
            <img src={lugar35} alt="Lugar Histórico de Escalonilla 35" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar36, "Lugar Histórico de Escalonilla 36")}>
            <img src={lugar36} alt="Lugar Histórico de Escalonilla 36" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar37, "Lugar Histórico de Escalonilla 37")}>
            <img src={lugar37} alt="Lugar Histórico de Escalonilla 37" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar38, "Lugar Histórico de Escalonilla 38")}>
            <img src={lugar38} alt="Lugar Histórico de Escalonilla 38" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar39, "Lugar Histórico de Escalonilla 39")}>
            <img src={lugar39} alt="Lugar Histórico de Escalonilla 39" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar40, "Lugar Histórico de Escalonilla 40")}>
            <img src={lugar40} alt="Lugar Histórico de Escalonilla 40" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar42, "Lugar Histórico de Escalonilla 42")}>
            <img src={lugar42} alt="Lugar Histórico de Escalonilla 42" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar43, "Lugar Histórico de Escalonilla 43")}>
            <img src={lugar43} alt="Lugar Histórico de Escalonilla 43" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar45, "Lugar Histórico de Escalonilla 45")}>
            <img src={lugar45} alt="Lugar Histórico de Escalonilla 45" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar46, "Lugar Histórico de Escalonilla 46")}>
            <img src={lugar46} alt="Lugar Histórico de Escalonilla 46" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar47, "Lugar Histórico de Escalonilla 47")}>
            <img src={lugar47} alt="Lugar Histórico de Escalonilla 47" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar48, "Lugar Histórico de Escalonilla 48")}>
            <img src={lugar48} alt="Lugar Histórico de Escalonilla 48" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar49, "Lugar Histórico de Escalonilla 49")}>
            <img src={lugar49} alt="Lugar Histórico de Escalonilla 49" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar50, "Lugar Histórico de Escalonilla 50")}>
            <img src={lugar50} alt="Lugar Histórico de Escalonilla 50" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar51, "Lugar Histórico de Escalonilla 51")}>
            <img src={lugar51} alt="Lugar Histórico de Escalonilla 51" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar52, "Lugar Histórico de Escalonilla 52")}>
            <img src={lugar52} alt="Lugar Histórico de Escalonilla 52" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar53, "Lugar Histórico de Escalonilla 53")}>
            <img src={lugar53} alt="Lugar Histórico de Escalonilla 53" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar54, "Lugar Histórico de Escalonilla 54")}>
            <img src={lugar54} alt="Lugar Histórico de Escalonilla 54" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar55, "Lugar Histórico de Escalonilla 55")}>
            <img src={lugar55} alt="Lugar Histórico de Escalonilla 55" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar56, "Lugar Histórico de Escalonilla 56")}>
            <img src={lugar56} alt="Lugar Histórico de Escalonilla 56" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar57, "Lugar Histórico de Escalonilla 57")}>
            <img src={lugar57} alt="Lugar Histórico de Escalonilla 57" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar58, "Lugar Histórico de Escalonilla 58")}>
            <img src={lugar58} alt="Lugar Histórico de Escalonilla 58" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar59, "Lugar Histórico de Escalonilla 59")}>
            <img src={lugar59} alt="Lugar Histórico de Escalonilla 59" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar60, "Lugar Histórico de Escalonilla 60")}>
            <img src={lugar60} alt="Lugar Histórico de Escalonilla 60" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar61, "Lugar Histórico de Escalonilla 61")}>
            <img src={lugar61} alt="Lugar Histórico de Escalonilla 61" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar62, "Lugar Histórico de Escalonilla 62")}>
            <img src={lugar62} alt="Lugar Histórico de Escalonilla 62" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar63, "Lugar Histórico de Escalonilla 63")}>
            <img src={lugar63} alt="Lugar Histórico de Escalonilla 63" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar64, "Lugar Histórico de Escalonilla 64")}>
            <img src={lugar64} alt="Lugar Histórico de Escalonilla 64" />
          </div>
          <div className="foto-item" onClick={() => openModal(lugar65, "Lugar Histórico de Escalonilla 65")}>
            <img src={lugar65} alt="Lugar Histórico de Escalonilla 65" />
          </div>
        </div>
      </div>

      {/* Sección para futuras categorías */}
      <div className="categoria-section">
        <h2>Más categorías próximamente</h2>
        <p className="categoria-intro">
          Pronto añadiremos más categorías con fotografías de otros momentos especiales 
          de nuestro querido Escalonilla.
        </p>
      </div>

      {/* Modal para ver fotos en grande */}
      {modalImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            <img 
              src={modalImage.src} 
              alt={modalImage.alt}
              className="modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Fotos;
